    $(document).ready(function() {

	$('.athletes-video-grid').slick({
		dots: false,
		infinite: true,
    arrows: false,
		speed: 300,
		slidesToShow: 4,
		slidesToScroll: 1,
    prevArrow: '<div class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="12" viewBox="0 0 24 12" fill="none"><path d="M7 1L2 6L7 11" stroke="black" stroke-width="2" stroke-linecap="round"/><path d="M22.5 6H2" stroke="black" stroke-width="2" stroke-linecap="round"/></svg></div>',
		nextArrow: '<div class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="23" height="12" viewBox="0 0 23 12" fill="none"><path d="M16.5 1L21.5 6L16.5 11" stroke="black" stroke-width="2" stroke-linecap="round"/><path d="M1 6H21.5" stroke="black" stroke-width="2" stroke-linecap="round"/></svg></div>',
    responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 576,
      settings: {
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
  ]
	  });

    $('.klaviyo-form-section').parent().addClass('klaviyo-form-section-block-part');

    // video mute unmute
	var video = $('#video');
	var volumeControl = $('#volume-control');
	var volumeIconMute = $('#volume-icon-mute');
	var volumeIconUnmute = $('#volume-icon-unmute');

	volumeControl.on('click', function () {
		if (video.prop('muted')) {
			video.prop('muted', false);
			volumeIconMute.css('opacity', 0);
			volumeIconUnmute.css('opacity', 1);
		} else {
			video.prop('muted', true);
			volumeIconMute.css('opacity', 1);
			volumeIconUnmute.css('opacity', 0);
		}
	});
	// video mute unmute

  // video mute unmute
	var videoBlock = $('#video-block-perfect');
	var volumeControls = $('#volume-control-block');
	var volumeIconMuteBlock = $('#volume-icon-mute-block');
	var volumeIconUnmuteBlock = $('#volume-icon-unmute-block');

	volumeControls.on('click', function () {
		if (videoBlock.prop('muted')) {
			videoBlock.prop('muted', false);
			volumeIconMuteBlock.css('opacity', 0);
			volumeIconUnmuteBlock.css('opacity', 1);
		} else {
			videoBlock.prop('muted', true);
			volumeIconMuteBlock.css('opacity', 1);
			volumeIconUnmuteBlock.css('opacity', 0);
		}
	});
	// video mute unmute

	$(".lock-in-perfomance-review-slider").slick({
		dots: true,
		arrows: false,
		slidesToShow: 1,
		slidesToScroll: 1,
	});
});


const toggleBtn = document.querySelector(".benefits-toggle");
  const box = document.querySelector(".benefits-box");

  toggleBtn.addEventListener("click", () => {
    box.classList.toggle("active");
  });


  function toggleFilter() {
  document.getElementById("mobileFilter").classList.toggle("active");
  document.getElementById("filterOverlay").classList.toggle("active");
  document.body.classList.toggle("filter-open");
}






